import { Button, Modal, Typography } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { getMediaUrl } from "@Utils";
import { IActivityDetails } from "@Models/IActivityDetails";
import IconButton from "@Components/shared/IconButton";

interface IProps {
    activity: IActivityDetails;
}

const ActivityCopy: React.FC<IProps> = ({ activity }: IProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCopy = async () => {
        await navigator.clipboard.writeText(videoInfo);
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const { Paragraph, Title } = Typography;
    const videoInfo = JSON.stringify(
        {
            Title: activity.activityName,
            Label: activity.activityLabel,
            ElementType: "Video",
            Content: getMediaUrl(activity.activityGuid, "video.mp4"),
            Preview: getMediaUrl(activity.activityGuid, "thumb.0000000.jpg"),
        },
        null,
        2
    );

    return (
        <>
            <IconButton onClick={showModal} className="secondary" icon={<CopyOutlined />}>
                Copy
            </IconButton>
            <Modal
                closable={false}
                visible={isModalOpen}
                footer={[
                    <Button onClick={handleCancel} className="secondary danger">
                        Cancel
                    </Button>,
                    <Button onClick={handleCopy} className="secondary">
                        Copy
                    </Button>,
                ]}
            >
                <Title level={4}>Video Information</Title>
                <Paragraph>
                    <pre>{videoInfo}</pre>
                </Paragraph>
            </Modal>
        </>
    );
};

export default ActivityCopy;
